export const LOGIN = 'Login';
export const LOGOUT = 'LogOut';

export type ActionType = 'Login' | 'LogOut';
